<template>
  <FriedModal class="access-denied-modal" @close="$emit('close')">
    <template #header>
      <FriedModalHeader :header="t('accessDeniedHeader')" />
    </template>
    <p>
      {{ t('accessDeniedBody') }}
    </p>
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton
          data-external="access-denied-modal-ok-button"
          button-type="primary"
          @click="$emit('close')"
          >{{ t('Ok') }}</FriedButton
        >
      </FriedModalButtonsFooter>
    </template>
  </FriedModal>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
defineEmits<{
  close: [];
}>();
</script>
